import React from "react";
import { Link } from "react-router-dom";
import CustomPagination from "../CustomPaginaition";

const PaginationControls = ({
  currentPage,
  totalPages,
  onPageChange,
  tablePage,
  tableTotalPage,
  tableTotal,
  t
}) => {
  return (
    <div className="row align-items-center mt-2 g-3 p-2">
      <div className="col-sm">
        <ul className="pagination pagination-separated pagination-md justify-content-center justify-content-sm-start mb-0">
          <li className={currentPage > 1 ? "page-item" : "page-item disabled"}>
            <Link
              to="#"
              className="page-link"
              onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
            >
              <i className="fa fa-chevron-left"></i>
            </Link>
          </li>

          {[...Array(totalPages).keys()].map((index) => (
            <CustomPagination
              key={index}
              item={index + 1}
              gotoPage={onPageChange}
              tablePage={tablePage}
              tableTotalPage={tableTotalPage}
            />
          ))}

          <li
            className={
              currentPage < totalPages ? "page-item" : "page-item disabled"
            }
          >
            <Link
              to="#"
              className="page-link"
              onClick={() =>
                currentPage < totalPages && onPageChange(currentPage + 1)
              }
            >
              <i className="fa fa-chevron-right"></i>
            </Link>
          </li>
        </ul>
      </div>
      <div className="col-sm-auto">
        <div className="text-muted">
          {t("showing")} <span className="fw-semibold">{tablePage?.length}</span> {t("of")}{" "}
          <span className="fw-semibold">{tableTotal}</span> {t("results")}
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;
